import { render, staticRenderFns } from "./LevelUpXPDialog.vue?vue&type=template&id=8ed28812&"
import script from "./LevelUpXPDialog.vue?vue&type=script&lang=js&"
export * from "./LevelUpXPDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports